import React from 'react';
import { MessageCircle } from 'lucide-react';
import { useSiteSettings, pick } from '@/contexts/SiteSettingsContext';
import { useLanguage } from '@/contexts/LanguageContext';

export default function WhatsAppButton() {
  const { settings } = useSiteSettings();
  const { lang } = useLanguage();
  const number = pick(settings?.whatsapp, '+971522898249').replace(/[^\d+]/g, '');
  const msg = lang === 'ar'
    ? 'مرحباً جُليد، أرغب في الاستفسار عن خدمات التمويل العقاري.'
    : 'Hello Guleed Mortgage, I would like to enquire about mortgage services.';
  const href = `https://wa.me/${number.replace(/^\+/, '')}?text=${encodeURIComponent(msg)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-button"
      className="fixed bottom-6 z-50 w-[60px] h-[60px] bg-[#25D366] rounded-full flex items-center justify-center shadow-[0_12px_30px_-8px_rgba(37,211,102,0.55)] hover:scale-110 hover:shadow-[0_16px_40px_-8px_rgba(37,211,102,0.7)] gmre-ios-transition wa-pulse"
      style={{ right: lang === 'ar' ? 'auto' : '24px', left: lang === 'ar' ? '24px' : 'auto' }}
    >
      <MessageCircle className="w-7 h-7 text-white fill-white" />
    </a>
  );
}
